import b_ from 'b_';
import cx from 'classnames';
import { Checkmark, Link as LinkIcon } from 'education-icons';
import { Button, Text, Tooltip, Popup } from 'platform-components';
import { POPUP_AXIS, POPUP_DIRECTIONS, POPUP_THEMES } from 'platform-components/constants';
import { getMe } from 'platform-components/src/components/user/selectors';
import { copyTextToClipboard } from 'platform-components/utils';
import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import ym from 'react-yandex-metrika';
import './lesson-copy-link.scss';

const COPY_LINK_TOOLTIP_TEXT_IDS = {
    COPY: 'lesson.settings.copyLinkTooltip.copy',
    COPIED: 'lesson.settings.copyLinkTooltip.copied',
};

const COPY_LINK_TOOLTIP_STATE = {
    COPY: 'copy',
    COPIED: 'copied',
};

interface OwnProps {
    childLink: string;
    clessonId: number;
    mix?: string;
}

export interface Props extends OwnProps {}

const b = b_.with('lesson-copy-link');

export const LessonCopyLink = ({ childLink, clessonId, mix }: Props) => {
    const [copyLinkTooltipMode, setCopyLinkTooltipMode] = useState(COPY_LINK_TOOLTIP_STATE.COPY);
    const copyLinkRef = useRef<HTMLDivElement | null>(null);
    const copyLinkPopupRef = useRef<Popup | null>(null);
    const me = useSelector(getMe);

    const handleCopyLessonLink = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        e.stopPropagation();

        copyTextToClipboard(childLink);

        ym('reachGoal', 'teacher_copy_lesson_link', {
            user_id: me?.id,
            clesson_id: clessonId,
            from: 'my_lessons',
        });

        setCopyLinkTooltipMode(COPY_LINK_TOOLTIP_STATE.COPIED);

        if (copyLinkPopupRef && copyLinkPopupRef.current && copyLinkRef && copyLinkRef.current) {
            copyLinkPopupRef.current.setOwner(copyLinkRef.current);
        }
    };

    const handleCopyLessonLinkMouseOver = () => {
        if (copyLinkPopupRef && copyLinkPopupRef.current && copyLinkRef && copyLinkRef.current) {
            copyLinkPopupRef.current.setOwner(copyLinkRef.current);

            copyLinkPopupRef.current.show();
        }
    };

    const handleCopyLessonLinkMouseLeave = () => {
        if (copyLinkPopupRef && copyLinkPopupRef.current) {
            copyLinkPopupRef.current.hide();

            if (copyLinkTooltipMode === COPY_LINK_TOOLTIP_STATE.COPIED) {
                setCopyLinkTooltipMode(COPY_LINK_TOOLTIP_STATE.COPY);
            }
        }
    };

    const shouldShowCopyTooltip = copyLinkTooltipMode === COPY_LINK_TOOLTIP_STATE.COPY;

    return (
        <div className={cx(b(), mix)}>
            <Button
                icon={<LinkIcon className={b('link-icon')} />}
                innerRef={copyLinkRef}
                onClick={handleCopyLessonLink}
                onMouseEnter={handleCopyLessonLinkMouseOver}
                onMouseLeave={handleCopyLessonLinkMouseLeave}
                size={Button.SIZE.S}
                view={Button.VIEW.CLEAR}
            />
            <Tooltip
                onPopupRef={copyLinkPopupRef}
                popupProps={{
                    autoclosable: true,
                    selfclosable: true,
                    shown: false,
                    axis: POPUP_AXIS.CENTER,
                    offsetTop: -36,
                    direction: POPUP_DIRECTIONS.TOP,
                    mix: b('tooltip-on-hover'),
                    theme: POPUP_THEMES.DARK_ROUNDED,
                }}
            >
                {shouldShowCopyTooltip ? (
                    <div className={cx(b('tooltip-content'), 'qa_tooltip-to-copy')}>
                        <Text id={COPY_LINK_TOOLTIP_TEXT_IDS.COPY} />
                    </div>
                ) : (
                    <div className={cx(b('tooltip-content'), 'qa_tooltip-copied')}>
                        <Checkmark className={b('tooltip-icon', { success: true })} />
                        <Text id={COPY_LINK_TOOLTIP_TEXT_IDS.COPIED} />
                    </div>
                )}
            </Tooltip>
        </div>
    );
};
